/* eslint-disable @typescript-eslint/no-explicit-any */
import CountUp from 'react-countup';
import { LegacyRef } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import moneyIcon from 'assets/img/icons/money-icon.svg';
import cashIcon from 'assets/img/icons/cash-icon.svg';
import dashboardService from 'service/dashboard';
import styles from './styles.module.scss';
import { useAppContext } from 'providers/AppProvider';
import { MoneyIconSmall, CashIconMini } from 'assets/img/icons/icons';
import { useWindowWidth } from 'utils/useWindowSize';

interface ProfitAndCostInfoProps {
  selectedCurrencyId?: any;
  dateFrom?: any;
  dateTo?: any;
  selectedBranchId?: string;
}

const ProfitAndCostInfo = ({
  selectedCurrencyId,
  dateFrom,
  dateTo,
  selectedBranchId
}: ProfitAndCostInfoProps) => {
  const { t } = useTranslation();
  const windowSize: any = useWindowWidth();
  const {
    config: { theme }
  } = useAppContext();

  //Get CASHFLOW
  const { data } = useQuery(
    ['GET_CASHFLOW', dateFrom, dateTo, selectedCurrencyId, selectedBranchId],
    () => {
      if (selectedCurrencyId !== '' && dateFrom && selectedBranchId !== '') {
        const res = dashboardService
          .getCashflow({
            offset: 0,
            limit: 10,
            date_from: dateFrom,
            date_to: dateTo,
            currency_pid: selectedCurrencyId,
            branch_pid: selectedBranchId
          })
          .then((res: any) => res);
        return res;
      }
    },
    { enabled: Boolean(dateFrom && selectedCurrencyId && selectedBranchId) }
  );

  return (
    <div
      className={
        theme === 'dark' ? styles.infoConteinerDark : styles.infoConteiner
      }
    >
      <div className={styles.box}>
        {windowSize < 768 && (
          <span className={styles.miniIcon}>
            <MoneyIconSmall />
          </span>
        )}
        <div className={styles.boxInfo}>
          <p className={styles.boxTitle}>{t('gross_profit')}</p>
          <CountUp
            end={data?.gross_profit_amount ?? 0}
            duration={2.75}
            suffix={+selectedCurrencyId === 2 ? ` ${t('sum')}` : ' $'}
            separator=" "
            delay={0}
          >
            {({ countUpRef }) => (
              <div>
                <span
                  className={styles.boxCount}
                  ref={countUpRef as LegacyRef<HTMLHeadingElement>}
                ></span>
              </div>
            )}
          </CountUp>
        </div>
        {windowSize > 768 && <img src={moneyIcon} alt="icon" />}
      </div>

      <div className={styles.box}>
        {windowSize < 768 && (
          <span className={styles.miniIcon}>
            <CashIconMini />
          </span>
        )}
        <div className={styles.boxInfo}>
          <p className={styles.boxTitle}>{t('cost')}</p>
          <CountUp
            end={data?.expense_amount ?? 0}
            duration={2.75}
            suffix={+selectedCurrencyId === 2 ? ` ${t('sum')}` : ' $'}
            separator=" "
            delay={0}
          >
            {({ countUpRef }) => (
              <div>
                <span
                  className={styles.boxCount}
                  ref={countUpRef as LegacyRef<HTMLHeadingElement>}
                ></span>
              </div>
            )}
          </CountUp>
        </div>
        {windowSize > 768 && <img src={cashIcon} alt="icon" />}
      </div>
    </div>
  );
};

export default ProfitAndCostInfo;
